export function useApiAutoComplete() {
  const { $api } = useNuxtApp();
  const { locale } = useI18n();

  const testingStore = useTestingStore();

  const useNewAutoCompleteService = testingStore.hasEnabledFeature('web_newAutoCompleteService');
  const newAutoCompleteVars = testingStore.getFeatureVariables('web_newAutoCompleteService');

  const defaultQuery = {};

  const defaultHeaders = { 'Accept-Language': locale?.value };

  const abortController = ref(null);

  const abortSearch = () => {
    if (abortController.value) {
      abortController.value.abort();
      abortController.value = null;
    }
  };

  const searchForTerm = async (term, version) => {
    const versionName = ['variation', 'control'].includes(version) ? version : null;

    if (abortController.value !== null) {
      abortSearch();
    }

    abortController.value = new AbortController();

    const searchTermHeaders = useNewAutoCompleteService
      ? {
        ...defaultHeaders,
        'accept': 'application/json',
        'x-flag-switch-db': newAutoCompleteVars?.selectedDB || '',
      }
      : defaultHeaders;

    const versionParam = versionName || (useNewAutoCompleteService ? 'variation' : 'control');

    const searchTermParams = {
      text: term,
      v: versionParam,
    };

    const result = ref(await $api.acapi(null, '', searchTermHeaders, defaultQuery, searchTermParams));

    return result?.value || null;
  };

  return {
    searchForTerm,
    abortSearch,
  };
}
